const linkRequestFragment = /* GraphQL */ `
  fragment linkRequestFragment on SearchResponseFacetOption {
    linkRequest {
      brands
      requestIdentifier
      categories
      subcategories
      partTypes
      year
      make
      model
      vehicleBase
      markets
      superMarkets
      raceType
      engineFamilies
      engineSubfamilies
      transmissionFamilies
      rearEndFamilies
      applications
      attributes
      productLines
      misc
      rebates
      canShipFree
      shipsFree
      platforms
      searchQuery
      availabilities
      garageSales
      chassis
      sanctioningBodies
      engineManufacturer
      engineMake
      engineSeries
      engineConfiguration
      engineVersion
      engineQualifier
      engineDisplacement
      engineFuelSystem
      engineCamshaftType
      engineCode
      price {
        min
        max
      }
      rating {
        min
        max
      }
      sortType
    }
  }
`

export default linkRequestFragment
